define('lib/jquery.richtext',['jquery', 'utils/common', 'form/file', 'lib/table', 'lib/redactor', 'lib/redactor-nl'], function ($) {
	RedactorPlugins.quote = function () {
		return {
			init: function () {
				var button = this.button.add('quote', 'Quote');
				this.button.addCallback(button, this.quote.quote);
			},
			quote: function (buttonName) {
				//var text = this.selection.wrap('blockquote');
				//this.selection.replaceSelection('<div><span class="author">Auteur</span><blockquote>'+this.selection.getHtml()+'</blockquote></div>');
				this.insert.htmlWithoutClean('<div class="quote"><span class="author">Auteur schreef:</span><blockquote>'+this.selection.getHtml()+'</blockquote></div><br/>');
			}
		};
	};
	
	$.fn.richtext = function(options) {
		var settings = $.extend({
			advanced: false,
			fileUpload : true,
			linkSize : 100
		}, options);
		
		//Uploaden niet toegestaan voor gasten
		if ($.userId()==0)
			settings.fileUpload = false;

		var buttons = ['html', 'bold', 'italic', 'deleted', 'underline','button1', 'link', 'table', 'image'];
		
		if (settings.fileUpload)
			buttons.push('file');
		
		buttons = $.merge(
			settings.advanced?['formatting', 'alignment', 'unorderedlist', 'orderedlist', 'outdent', 'indent']:['quote'],
			buttons
		);

		return this.each(function () {
			var el = $(this);

            if (!$('<div/>')[0].contentEditable == 'inherit') {
                // Geen richtext als contenteditable niet wordt ondersteund (zodat keyboard werkt op oude android browsers)
                // Check is gejat van modernizr
                return false;
            }
			
			var _settings = {
				linebreaks: true,
				toolbarFixed: true,
				buttonSource: true,
				focus: false,
				plugins: ['table', 'quote'],
				replaceDivs: false,
			 	buttonsCustom: {
			 		button1: {
			 			title: 'Quote',
			 			callback: function() {
			 				this.insertHtml('<div class="quote"><span data-redactor="verified"><span class="author">Persoon</span> schreef:</span><blockquote><p>'+this.getSelectionHtml()+'<br></p></blockquote></div><p><br></p>');
							this.selectionRemove();
			 			}
			 		}
				},
				buttons: buttons,
				lang: 'nl',
				linkify: {
					regexps: {
						youtube: /$a/ig,
						vimeo: /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/,
						image: /((https?|www)[^\s]+\.)(jpe?g|png|gif)(\?[^\s-]+)?/ig,
						url: /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/ig,
					}
				}
			};
			
			// file upload or not!
			if(settings.fileUpload) {
				var fileWidget = $('#'+el.data('filewidget'));
				_settings = $.extend(_settings, {
					fileUpload: $.url('/file/upload', {id: fileWidget.data('id'), key: fileWidget.data('key')}),
					fileUploadCallback : function (obj, json) {
						fileWidget.data('widget').add(json);
					},
					imageUpload: $.url('/image/upload', {id: fileWidget.data('id'), size: el.data('size'), key: fileWidget.data('key')}),
					imageUploadCallback : function (obj, json) {
						fileWidget.data('widget').add(json);
					},
					uploadFileFields: {
						token : $('meta[name=csrf]').attr("content")
					},
					uploadImageFields: {
						token : $('meta[name=csrf]').attr("content")
					}
				});
			}
			
			return el.redactor(_settings);				
		});
	};

});
